import { useState, useEffect } from "react";
import { apiFetch } from "../api";

function fetchClient() {
  return apiFetch(`/api/v2/me`)
    .then((resp) => resp.json())
    .catch((err) => {
      console.error(err);
      throw err;
    });
}

export function useClient() {
  const [client, setClient] = useState(null);
  useEffect(() => {
    fetchClient()
      .then((a) => {
        if (a && a.client) {
          setClient(a.user);
        } else {
          setClient({ tickets: [] });
        }
      })
      .catch(() => setClient({ tickets: [] }));
  }, []);

  return { client };
}
